<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/citations/issued/new" Label="Create Citation"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/citations/searches"
  [AllowEdit]="true" EditUrl="enforcement/citations/issued/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-single-date-filter DateSearchProperty="IssuedDate" Placeholder="Filter by date..."></div>
    <div app-officers-filter></div>
    <div app-infringement-types-filter></div>
    <div app-subset-filter [Subsets]="getStatuses()" Subset="Open"></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 